export default __webpack_public_path__ + "static/media/883.2af5f9d4.png";